
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tech",
      function () {
        return require("private-next-pages/tech/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tech"])
      });
    }
  